import CustomLoader from './Loader';
export default CustomLoader;
